import { enqueueSnackbar } from "notistack";
import React from "react";
import { useTranslation } from "react-i18next";

import { ConfirmationDialog } from "@/components/modals/ConfirmationDialog";

import { useDeleteTemplateMutation } from "./templateApi";

export function DeleteTemplateModal({
  show,
  close,
  id,
  name,
  refetchTemplateList,
}: {
  show: boolean;
  close: () => void;
  id: string;
  name: string;
  refetchTemplateList?: () => void;
}) {
  const [deleteTemplate, { isLoading }] = useDeleteTemplateMutation();

  const { t } = useTranslation();

  const clickDeleteTemplate = async () => {
    try {
      await deleteTemplate(id).unwrap();
      enqueueSnackbar(t("The template was successfully deleted"), {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar(error.data, {
        variant: "error",
        style: { whiteSpace: "pre-line" },
      });
    }
    refetchTemplateList?.();
  };

  return (
    <ConfirmationDialog
      isShown={show}
      onCancel={close}
      onConfirm={clickDeleteTemplate}
      onConfirmText={t("Delete this template")}
      onCancelText={t("Cancel")}
      title={t("Are you sure you want to delete this template ?")}
      isLoading={isLoading}
      content={name}
    />
  );
}
